import React from "react";

const STARS = [1, 2, 3, 4, 5];

/**
 * 1–5 rating shown as yellow stars with the number centered inside each star.
 * Stars up to `value` are filled amber; the rest are light gray.
 */
function StarRating({ value = 0, onChange, size = 40, ariaLabel = "Calificación" }) {
  return (
    <div className="d-flex gap-1" role="group" aria-label={ariaLabel}>
      {STARS.map((v) => {
        const active = v <= value;
        return (
          <button
            key={v}
            type="button"
            onClick={() => onChange(v)}
            aria-label={`${v} de 5`}
            aria-pressed={value === v}
            title={`${v}`}
            style={{
              position: "relative",
              width: size,
              height: size,
              minWidth: 44,
              minHeight: 44,
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            <span
              aria-hidden="true"
              style={{
                fontSize: size,
                lineHeight: 1,
                display: "block",
                color: active ? "#FFC107" : "#DCDCDC",
              }}
            >
              ★
            </span>
            <span
              aria-hidden="true"
              style={{
                position: "absolute",
                top: "47%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: Math.round(size * 0.38),
                fontWeight: 700,
                color: active ? "#5d4200" : "#9e9e9e",
              }}
            >
              {v}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export { StarRating };
